import { Category } from "@/lib/types";

// Each category ships with an art-directed image, with its gradient kept as
// a backdrop shown while the image loads (and as a graceful fallback).
export const categories: Category[] = [
  {
    slug: "marvel",
    name: "Marvel",
    tagline: "Second-hand figures, comics and collectibles.",
    gradient:
      "radial-gradient(120% 120% at 20% 10%, #7a1f2b 0%, #2a0a14 45%, #141d33 100%)",
    accent: "#e63950",
    image: "/images/categories/marvel.webp?v=cosmic-2",
  },
  {
    slug: "anime-manga",
    name: "Anime & Manga",
    tagline: "Figures, manga, statues and collector finds.",
    gradient:
      "radial-gradient(120% 120% at 80% 10%, #6b2fa0 0%, #2a1240 45%, #141d33 100%)",
    accent: "#c084fc",
    image: "/images/categories/anime-manga.webp?v=cosmic-2",
  },
  {
    slug: "gaming",
    name: "Gaming",
    tagline: "Retro consoles, accessories and collectibles.",
    gradient:
      "radial-gradient(120% 120% at 20% 90%, #0f6e6e 0%, #0c2e35 45%, #141d33 100%)",
    accent: "#2dd4bf",
    image: "/images/categories/gaming.webp?v=cosmic-2",
  },
  {
    slug: "pokemon",
    name: "Pokémon",
    tagline: "Cards, figures, games and collector pieces.",
    gradient:
      "radial-gradient(120% 120% at 80% 90%, #b45309 0%, #3a2408 45%, #141d33 100%)",
    accent: "#facc15",
    image: "/images/categories/pokemon.webp?v=cosmic-2",
  },
  {
    slug: "star-wars",
    name: "Star Wars",
    tagline: "Figures, memorabilia and collector finds.",
    gradient:
      "radial-gradient(120% 120% at 50% 0%, #1e3a8a 0%, #0e1a3a 45%, #141d33 100%)",
    accent: "#60a5fa",
    image: "/images/categories/star-wars.webp?v=cosmic-2",
  },
  {
    slug: "lego",
    name: "LEGO",
    tagline: "Collector sets and minifigures.",
    gradient:
      "radial-gradient(120% 120% at 50% 100%, #b91c1c 0%, #3a0f0f 45%, #141d33 100%)",
    accent: "#fb7185",
    image: "/images/categories/lego.webp?v=cosmic-2",
  },
  {
    slug: "comics",
    name: "Comics",
    tagline: "Second-hand comics and graphic novels.",
    gradient:
      "radial-gradient(120% 120% at 20% 50%, #5b21b6 0%, #1e0f3a 45%, #141d33 100%)",
    accent: "#a78bfa",
    image: "/images/categories/comics.webp?v=cosmic-2",
  },
  {
    slug: "figures-statues",
    name: "Figures & Statues",
    tagline: "Premium statues displayed with dramatic lighting.",
    gradient:
      "radial-gradient(120% 120% at 80% 50%, #1e40af 0%, #0e1a3a 45%, #141d33 100%)",
    accent: "#818cf8",
    image: "/images/categories/figures-statues.webp?v=cosmic-2",
  },
  {
    slug: "collectibles",
    name: "Collectibles",
    tagline: "Rare and curated collector pieces.",
    gradient:
      "radial-gradient(120% 120% at 50% 20%, #0e7490 0%, #0b2a35 45%, #141d33 100%)",
    accent: "#22d3ee",
    image: "/images/categories/collectibles.webp?v=cosmic-2",
  },
  {
    slug: "trading-cards",
    name: "Trading Cards",
    tagline: "Graded, sleeved and binder-fresh cards.",
    gradient:
      "radial-gradient(120% 120% at 30% 70%, #9d174d 0%, #350a1e 45%, #141d33 100%)",
    accent: "#f472b6",
    image: "/images/categories/trading-cards.webp?v=cosmic-2",
  },
];

export function getCategory(slug: string) {
  return categories.find((c) => c.slug === slug);
}
